import {useSelector} from 'react-redux';

import Utility from '../../../util/utilityfunctions';
import {riskTypeIds, groupRiskStatus} from '../../../util/uiconstants';

const sortAccountData = (primaryAccounts) => [...Utility.sortListData(primaryAccounts, 'accountName')];

const sortRiskData = (risks) => {
	const filterIt = (typeId) => ({riskTypeId}) => riskTypeId === typeId;
	const sr = risks.filter(filterIt(riskTypeIds.significant));
	const fr = risks.filter(filterIt(riskTypeIds.fraud));
	const ir = risks.filter(filterIt(riskTypeIds.insignificant));

	const sortIt = (riskList) => Utility.sortListData(riskList, 'riskName');

	return [...sortIt(sr), ...sortIt(fr), ...sortIt(ir)];
};

const normalizeRiskData = (risks) =>
	sortRiskData(risks).map((risk) => ({
		...risk,
		relatedRisks: risk.relatedRisks,
		accounts: risk.accounts
	}));

export default (isAccounts = false, riskStatusId = [groupRiskStatus.open, groupRiskStatus.systemReOpened]) =>
	useSelector(({reconciliations}) => {
		const {primaryAccounts, primaryRisks} = reconciliations.selected;
		if (primaryAccounts === null || primaryRisks === null) return null;

		const baseData = isAccounts ? sortAccountData(primaryAccounts) : normalizeRiskData(primaryRisks);
		return baseData.filter(({groupRiskStatusId}) => riskStatusId.includes(groupRiskStatusId));
	});
